import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng-fe/ui_base';
import { Share } from '@ifeng-fe/ui_pc_share';
import errorBoundary from '@ifeng-fe/errorBoundary';

const config = {
    items: ['sina', 'wechat', 'qqzone'],
    display: 'gray',
    hover: 'filling',
    type: 'vertical',
    methods: 'hover',
    tooltip: 'left',
};

class Affix extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isToTopShow: false,
    };

    componentDidMount() {
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        if (currentTop > 100) {
            this.setState({ isToTopShow: true });
        } else {
            this.setState({ isToTopShow: false });
        }
    };

    /**
     * 回到顶部
     */
    backToTop = () => {
        scrollTo(0, 0);
    };

    /**
     * 渲染组件
     */
    render() {
        const { isToTopShow } = this.state;
        const {
            content: { url, title, summary, picUrl },
        } = this.props;
        const shareInfo = {
            url,
            title,
            summary,
            picUrl,
        };

        const affix = (
            <React.Fragment>
                <div className={styles.bottom_affix}>
                    <Share config={config} shareInfo={shareInfo} />
                    {isToTopShow ? <span className={styles.backToTop} onClick={this.backToTop} /> : ''}
                </div>
            </React.Fragment>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
